import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="navbar">
      <Link to="/">Home</Link>
      <Link to="/currency-rates">Currency Rates</Link>
      <Link to="/news-feed">News Feed</Link>
    </nav>
  );
};

export default Navbar;
